import { Component, input, linkedSignal, output } from '@angular/core';

import { Filter, isFilter, PropertyFilter } from '@softline/core';
import { FormControl } from '@angular/forms';
import { FilterConfig } from '../../types/filter-config';
import { I18nModule } from '@softline/ui-core';
import { FilterComponent } from './filter/filter.component';

@Component({
    selector: 'soft-filter-list',
    imports: [I18nModule, FilterComponent],
    templateUrl: './filter-list.component.html',
    styleUrls: ['./filter-list.component.css']
})
export class FilterListComponent {

  form = new FormControl()

  filtersInput = input.required<Partial<Filter>[]>({alias: 'filters'});
  config = input.required<FilterConfig>();
  items = input.required<object[]>()

  filters = linkedSignal(() => this.filtersInput());
  filtersChange = output<Filter[]>()

  async onFilterChange(filter: Partial<Filter>, index: number): Promise<void> {
    const filters = [...this.filters()];
    filters.splice(index, 1, filter);
    this.filters.set(filters);
    if(filters.every(isFilter))
      this.filtersChange.emit(filters.filter(isFilter));
  }

  async onAddFilter(): Promise<void> {
    const filters = [...this.filters(), {}]
    this.filters.set(filters);
    if(filters.every(isFilter))
      this.filtersChange.emit(filters.filter(isFilter));
  }

  async onRemove(filter: Partial<PropertyFilter>): Promise<void> {
    const filters = [...this.filters()];
    const index = filters.indexOf(filter);
    if(index > -1)
      filters.splice(index, 1);
    this.filters.set(filters);
    if(filters.every(isFilter))
      this.filtersChange.emit(filters.filter(isFilter));
  }

  async onRemoveAll(): Promise<void> {
    const filters = []
    this.filters.set(filters);
    if(filters.every(isFilter))
      this.filtersChange.emit(filters.filter(isFilter));
  }
}
